export default function(_this) {
  const workflowsPath = 'widgetsData/simpleWorkflows'

  return {
    read(cb) {
      _this.getRef(workflowsPath)
        .on('value', (snapshot) => {
          cb(snapshot.val() || {})
        })
    },
    add(cb) {
      const key = _this.getRef(workflowsPath)
        .push({}, () => {
          cb(key)
        }).key
    },
    save(key, workflow, cb) {
      _this.getRef(workflowsPath)
        .child(key)
        .set(workflow, () => {
          cb()
        })
    },
    remove(key, cb) {
      _this.getRef(workflowsPath)
        .child(key)
        .remove(() => {
          cb()
        })
    }
  }
}
